import { useMemo } from 'react';
import { getTranslations, type AppTranslations } from '@/locales';
import { useSurveyLanguage } from './useSurveyLanguage';

export function useTranslation(): { t: AppTranslations } {
  const { surveyLanguage } = useSurveyLanguage();
  const t = useMemo(() => getTranslations(surveyLanguage ?? 'en'), [surveyLanguage]);
  return { t };
}
